import { Center, Group, Stack, Text, Title } from 'ui';

import { centsToDollar } from '../../utils';

type AmountOverlineProps = {
  title: string;
  amount?: number;
  size?: 'lg' | 'sm';
  partial_amount?: string;
  removeTrailingCents?: boolean;
};

export const AmountOverline = ({
  title,
  amount,
  size = 'lg',
  partial_amount,
  removeTrailingCents = false,
}: AmountOverlineProps) => {
  const sizedSpacing = size === 'lg' ? 0 : 'xs';

  const sizedTitle =
    size === 'lg' ? (
      <Text type="sub">{title}</Text>
    ) : (
      <Text fz="xs" fw={500} c="gray">
        {title}
      </Text>
    );

  const sizedAmount =
    size === 'lg' ? (
      <Title order={1}>{centsToDollar(amount, removeTrailingCents)}</Title>
    ) : (
      <Text fz="lg" fw={600}>
        {centsToDollar(amount, removeTrailingCents)}
      </Text>
    );

  const sizedPartialAmount =
    size === 'lg' ? (
      <Text type="sub">{partial_amount}</Text>
    ) : (
      <Text fz="xs" fw={500} c="gray">
        {partial_amount}
      </Text>
    );

  if (amount === undefined || null) return null;

  return (
    <Stack gap={sizedSpacing}>
      {sizedTitle}
      <Group gap="sm" align="flex-end">
        {sizedAmount}
        <Center h={size === 'lg' ? 35 : 22}>{sizedPartialAmount}</Center>
      </Group>
    </Stack>
  );
};
